import { Box, Heading, Text, Flex } from '@chakra-ui/react';
import { useTranslation } from '../translations/useTranslation';

const MaintenancePage = () => {
  const { t } = useTranslation();
  return (
    <Flex
      direction="column"
      alignItems="center"
      justifyContent="center"
      minH="80vh"
    >
      <Box textAlign="center" py={10} px={6}>
        <Heading
          display="inline-block"
          as="h2"
          size="2xl"
          bgGradient="linear(to-r, teal.400, teal.600)"
          backgroundClip="text"
        >
          {t('serverDown')}
        </Heading>
        <Text fontSize="18px" mt={3} mb={2}>
          {t('maintenanceJoke')}
          <br />
          {t('maintenanceJokePunchline')}
        </Text>
        <Text color={"gray.500"} mb={6}>
          {t('maintenanceApology')}
        </Text>
      </Box>
    </Flex>
  );
};

export default MaintenancePage;


